export default "__VITE_ASSET__ueU6nif8__"